import './index.css';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { isMobileBrowser } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import { useDispatch } from 'react-redux';
import { transferfund } from '../../actions/account-actions-types';
import EventEmitter from '../../utilities/EventEmitter';
import { showToast } from '../../actions/app-actions-types';
import I18n from '../../utilities/locale';
import View from '../view';
import Text from '../text';
import Button from '@mui/material/Button/Button';
import React from 'react';

interface Props {
  visible: boolean;
  pokerWallet: any;
  gameWallet: any;
  onPressDismiss: any;
  isPokerWebView: boolean;
}
const TransferPokerModal = ({
  pokerWallet,
  gameWallet,
  visible,
  onPressDismiss
}: // isPokerWebView
Props) => {
  const bottomSheetWidth = isMobileBrowser ? 'root_mobile' : 'root';
  const className = `${bottomSheetWidth}`;
  const { AccountTheme: theme } = useTheme();
  const dispatch = useDispatch();

  const onPressTransfer = () => {
    const data = {
      fromWallet: 'poker'
    };
    dispatch(
      transferfund({
        data,
        callback: ({ error }: { error: any }) => {
          onPressDismiss();
          if (!error) {
            EventEmitter.emit('BalanceUpdate');
            dispatch(showToast(I18n.t('moneyTransferredSuccessfully')));
          }
        }
      })
    );
  };

  // const rawSheetColor = {
  //   backgroundColor: theme.modalContainer
  // };

  const containerColor = {
    backgroundColor: theme.modalContainer
  };

  const headerTextColor = {
    color: theme.transferMoneyHeaderTitle
  };

  const rowColor = {
    borderBottomColor: theme.transferMoneyRowBorder
  };

  const leftTextColor = {
    color: theme.transferMoneyModalTitle
  };

  const rightTextColor = {
    color: theme.transferMoneyModalValue
  };

  const areSureText = {
    color: theme.transferMoneyAreYouSureText
  };

  const yesBtnColor = {
    backgroundColor: theme.transferMoneyYesBtn
  };

  const noBtnColor = {
    backgroundColor: theme.transferMoneyNoBtn
  };

  return (
    <BottomSheet className={className} onDismiss={onPressDismiss} open={visible}>
      <View className={'transfer-poker-modal-container'} style={containerColor}>
        <View>
          <Text className={'transfer-poker-modal-header-text'} style={headerTextColor}>
            {I18n.t('Confirmation')}
          </Text>
          <View className={'transfer-poker-modal-content'}>
            <View className={'transfer-poker-modal-row '} style={rowColor}>
              <Text className={'transfer-poker-modal-left-text'} style={leftTextColor}>
                {'From : '}
                {I18n.t('PokerWallet')}
              </Text>
              <Text
                className={'transfer-poker-modal-right-text'}
                style={rightTextColor}>{`₹ ${pokerWallet}`}</Text>
            </View>
            <View className={'transfer-poker-modal-row'} style={rowColor}>
              <Text className={'transfer-poker-modal-left-text'} style={leftTextColor}>
                {'To : Winnings'}
              </Text>
              <Text
                className={'transfer-poker-modal-right-text'}
                style={rightTextColor}>{`₹ ${gameWallet}`}</Text>
            </View>
            <Text className={'transfer-poker-modal-are-sure'} style={areSureText}>
              {I18n.t('SureToCompleteTransfer')}
            </Text>
            <View className={'transfer-poker-modal-button-wrapper'}>
              <Button
                onClick={onPressTransfer}
                className={'transfer-poker-modal-button'}
                style={yesBtnColor}>
                {I18n.t('Yes')}
              </Button>
              <Button
                onClick={onPressDismiss}
                className={'transfer-poker-modal-button'}
                style={noBtnColor}>
                {I18n.t('No')}
              </Button>
            </View>
          </View>
        </View>
      </View>
    </BottomSheet>
  );
};
export default React.memo(TransferPokerModal);
